export default __webpack_public_path__ + "static/media/moly_with_hole.c378c4d0.svg";